module.exports = __webpack_public_path__ + "static/media/org-web.b087bbb4.svg";